import type { GlobalAiTranscriptMessage } from './global-ai-assistant-transcript';

const LEADING_FRAGMENT_JOINER = /^(for|in|at|by|from|with)\b/i;
const VALUE_CONNECTOR = /\b(for|in|at|by|from|with)\b/i;
const REQUEST_STARTER =
  /^(show|what|how|open|go|take me|create|build|make|add|compare|give me|tell me|can you|please)\b/i;
const ANALYTIC_REQUEST_KEYWORD =
  /\b(headcount|attrition|hiring|pay|postings?|sentiment|transitions?|composition|trends?|chart|dashboard)\b/i;
const SENTENCE_PUNCTUATION = /[.?!;:]/;
const MAX_VALUE_FRAGMENT_TOKENS = 4;

function isConcatenatableEntityValueFragment(prompt: string): boolean {
  const trimmed = prompt.trim();
  if (!trimmed) {
    return false;
  }
  if (SENTENCE_PUNCTUATION.test(trimmed)) {
    return false;
  }
  if (REQUEST_STARTER.test(trimmed)) {
    return false;
  }
  if (ANALYTIC_REQUEST_KEYWORD.test(trimmed)) {
    return false;
  }

  const tokens = trimmed.split(/\s+/).filter(Boolean);
  if (tokens.length > MAX_VALUE_FRAGMENT_TOKENS) {
    return false;
  }

  if (LEADING_FRAGMENT_JOINER.test(trimmed)) {
    return true;
  }

  return !VALUE_CONNECTOR.test(trimmed);
}

export function buildPromptForSubmit(input: {
  rawPrompt: string;
  lastUserPrompt: string | null;
  transcript: GlobalAiTranscriptMessage[];
}): string {
  const prompt = input.rawPrompt.trim();
  if (!prompt) {
    return prompt;
  }

  const previousPrompt = input.lastUserPrompt?.trim();
  const lastMessage = input.transcript[input.transcript.length - 1];
  if (
    !previousPrompt ||
    lastMessage?.role !== 'assistant' ||
    lastMessage.kind !== 'clarification' ||
    lastMessage.clarificationKind !== 'entity_value' ||
    !isConcatenatableEntityValueFragment(prompt)
  ) {
    return prompt;
  }

  const joiner = LEADING_FRAGMENT_JOINER.test(prompt) ? ' ' : ' for ';
  return `${previousPrompt}${joiner}${prompt}`;
}
